"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShowSalesOrderSummarySidePanelButton = void 0;
const React = require("react");
const TSalesOrderType_1 = require("../../../types/TSalesOrderType");
const standardSizes_1 = require("../../../../../../types/standardSizes");
const Button_1 = require("../../../../../../components/base/atoms/Button");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "ShowSalesOrderSummarySidePanelButton");
const ShowSalesOrderSummarySidePanelButton = ({ salesOrder, setOpen }) => {
    const { mainItemImage, type } = salesOrder;
    return (React.createElement("div", { className: css("", {
            ["-isDelivery"]: type === TSalesOrderType_1.TSalesOrderType.Delivery
        }) },
        React.createElement(Button_1.Button, { className: css("button"), onClick: () => setOpen(true), size: standardSizes_1.TStandardSizes.ExtraSmall },
            React.createElement("div", { className: css("button_mainItemImage"), style: { backgroundImage: `url("${mainItemImage}")` } }),
            React.createElement("div", { className: css("button_text") }, "order info"))));
};
exports.ShowSalesOrderSummarySidePanelButton = ShowSalesOrderSummarySidePanelButton;
//# sourceMappingURL=index.js.map